"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = exports.breakpoints = exports.createApiUrl = exports.apiConfig = exports.isLocalhost = exports.isProduction = exports.isDevelopment = void 0;
const Types_1 = require("./Types");
const env = process.env;
const win = global || window;
const NODE_ENV = (env.REACT_APP_ENV || env.NODE_ENV);
exports.isDevelopment = NODE_ENV === Types_1.AppEnvKeys.Development;
exports.isProduction = NODE_ENV === Types_1.AppEnvKeys.Production;
exports.isLocalhost = ['localhost', '127.0.0.1', '::1'].includes((_a = win === null || win === void 0 ? void 0 : win.location) === null || _a === void 0 ? void 0 : _a.hostname);
const resolveApiUrl = (environment) => {
    switch (environment) {
        case Types_1.AppEnvKeys.Production:
            return 'api.globalctgroup.com';
        case Types_1.AppEnvKeys.Staging:
            return 'staging-api.globalctgroup.com';
        case Types_1.AppEnvKeys.Test:
            return 'test-api.globalctgroup.com';
        case Types_1.AppEnvKeys.Development:
        default:
            return 'localhost';
    }
};
exports.apiConfig = {
    protocol: exports.isDevelopment ? Types_1.ApiProtocol.Http : Types_1.ApiProtocol.Https,
    url: env.REACT_APP_API || resolveApiUrl(env.REACT_APP_ENV),
    path: '',
    port: exports.isDevelopment ? 1337 : undefined,
};
const createApiUrl = ({ path, port, protocol, url, } = exports.apiConfig) => new URL(path || '', `${protocol}://${url}${(port && ':' + port) || ''}${path && '/' + path}`);
exports.createApiUrl = createApiUrl;
exports.breakpoints = [
    {
        type: Types_1.BreakpointTypes.Xxs,
        size: 370,
    },
    {
        type: Types_1.BreakpointTypes.Xs,
        size: 576,
    },
    {
        type: Types_1.BreakpointTypes.Sm,
        size: 768,
    },
    {
        type: Types_1.BreakpointTypes.Md,
        size: 992,
    },
    {
        type: Types_1.BreakpointTypes.Lg,
        size: 1200,
    },
    {
        type: Types_1.BreakpointTypes.Xl,
        size: 1550,
    },
];
const defaultConfig = () => ({
    api: {
        config: exports.apiConfig,
        createApiUrl: exports.createApiUrl,
        url: (0, exports.createApiUrl)(exports.apiConfig),
    },
    breakpoints: exports.breakpoints,
    cookieNames: {
        signInRedirect: 'sign-in-redirect',
    },
    env: {
        host: env.REACT_APP_HOST || 'localhost',
        protocol: env.REACT_APP_HTTPS === 'true' ? Types_1.ApiProtocol.Https : Types_1.ApiProtocol.Http,
        port: (env.REACT_APP_PORT && Number(env.REACT_APP_PORT)) || 3000,
        publicUrl: env.REACT_APP_PUBLIC_URL && env.REACT_APP_PUBLIC_URL.length > 0
            ? env.REACT_APP_PUBLIC_URL
            : undefined,
    },
    isDevelopment: exports.isDevelopment,
    isLocalhost: exports.isLocalhost,
});
exports.defaultConfig = defaultConfig;
